<template>
   <vs-row vs-justify="center">
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      
      <vs-card>
        <div class="d-md-flex align-items-center pb-2">
        <h3 class="card-title mb-0">Agen {{this.$route.params.ref}}</h3>
        <div class="ml-auto">
          <vs-button @click="backpage" color="danger" type="filled" class="mt-4 mt-md-0" icon="highlight_off" v-focus>
           Batal
          </vs-button>
        </div> 
        </div>
        <vs-alert v-if="errors.length" class="mb-3 mt-2"  color="danger">
            <b>Terdapat Kesalahan..</b>
            <ul class="common-list">
            <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </vs-alert>
        <div>
          <vs-row>
            <vs-col vs-lg="2" vs-xs="12" vs-sm="3">  
                <vs-input label="KODE" class="w-100 mt-4" ref="transval" v-model="formdata.kode" /> 
            </vs-col>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="3">  
                <vs-input label="NAMA" class="w-100 mt-4" ref="transval" v-model="formdata.nama" /> 
            </vs-col>
          </vs-row>
          <vs-row>
             <vs-col vs-lg="12" vs-xs="12" vs-sm="4"> 
              <vs-textarea label="ALAMAT" ref="alamat" v-model.lazy="formdata.alamat" class="mt-4 w-100" />
             </vs-col>
          </vs-row>
          <vs-row>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="4">  
            <vs-select class="w-100 mt-4" label="PROPINSI" v-model="formdata.prop_id">
              <vs-select-item
                :key="index"
                :value="item.prop_id"
                :text="item.prop_nama"
                v-for="(item,index) in optpropinsi"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="4">  
            <vs-select class="w-100 mt-4" label="KABUPATEN" v-model="formdata.kab_id">
              <vs-select-item
                :key="index"
                :value="item.kab_id"
                :text="item.kab_nama"
                v-for="(item,index) in optkabupaten"
              />
            </vs-select>
          </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-lg="5" vs-xs="12" vs-sm="3">  
                <vs-input label="PIC" class="w-100 mt-4" ref="transval" v-model="formdata.pic" /> 
            </vs-col>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="3">  
                <vs-input label="TELP" class="w-100 mt-4" ref="transval" v-model="formdata.telp" /> 
            </vs-col>
            <vs-col vs-lg="3" vs-xs="12" vs-sm="4">  
            <div class="vs-component vs-con-input-label vs-input w-100 mt-4 vs-input-primary">  
            <label class="vs-input--label" >TGL BERGABUNG</label>
            <div class="vs-con-input">
            <date-picker
            v-model="formdata.tgl_gabung"
            format="YYYY-MM-DD"
            value-type="format"
            placeholder="Pilih Tgl" input-class="vs-input--input">
            </date-picker>
            </div>
            </div>
          </vs-col>
          </vs-row>
        </div>
        <div class="btn-alignment mt-4">
          <vs-button color="success" type="filled" @click.stop.prevent="checkForm">Simpan</vs-button>
          <vs-button color="dark" @click="backpage" type="filled">Batal</vs-button>
        </div>
      </vs-card>
    </vs-col>
    
   </vs-row>
</template>

<script>
  /* eslint-disable no-console */
  /* eslint-disable no-case-declarations */
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';  
  

  export default {
    components: {
      DatePicker,
    },  
    data: function () {
      return {
        // eslint-disable-next-line
        datetrans: '',
        formdata: {
            jenis:'agen',
            kode:'',
            nama:'',
            alamat:'',
            prop_id:'',
            kab_id:'',
            pic:'',
            telp:'',
            tgl_gabung:'',
            isEdit: false,
            prevReferensi:''
        },
        errors:[],
        optpropinsi:[],
        optkabupaten:[],
        idtrans:0,
        inputUrl: '/api/agent'
      }
    },
    methods:{
        backpage: function(){
            this.$router.go(-1);
        },
        getAllData: function(){
            this.$http.get('/api/wilayahlist').then(response => {
                //console.log(response.data);
                this.optpropinsi = response.data
            }).catch(error=>{
                //console.log(error);
            });
            //edit mode init data
            if(this.$route.params.ref != null){
                this.formdata.isEdit = true
                this.$http.get(this.inputUrl+"/"+this.$route.params.ref).then(response => {
                    console.log(response.data)
                    //this.formdata.datatrans = response.data;
                    const keys = Object.keys(response.data)
                    console.log(keys)
                    var self = this
                    for(const key of keys){
                        //console.log(key)
                        if (this.formdata.hasOwnProperty(key))
                            this.formdata[key] = response.data[key]
                        if(key == 'nik'){
                            console.log('kode masuk')
                            this.formdata.prevReferensi = response.data[key]
                        }
                            
                    }
                }).catch(error=>{
                    console.log(error)
                    this.$vs.notify({title:'Error',text:'Gagal inisiasi data, silahkan coba lagi...',color:'danger'})
                });
            }
            //edit mode init data

            this.formdata.pemohon_id = this.$store.getters.getUserId
        },
        checkForm:function(e) {
            this.errors = [];
            //cek dari client dulu...
            
            if(this.formdata.kode == ''){
                this.errors.push("KODE belum terisi...")
            }

            if(this.formdata.nama == ''){
                this.errors.push("Nama belum terisi...")
            }


            if(this.errors.length > 0){
                this.handleError(this.error,'local')
            }
            else{
                this.$vs.loading({'type':'radius'})
                this.$http.post(this.inputUrl,{
                    formdata : this.formdata
                }).then(response => {
                    console.log(response);
                    this.handleSuccess();
                    //
                }).catch(error=>{
                    console.log(error.response)
                    this.handleError(error)
                })
            }
        },
        handleError: function(error,type=''){
            if(type != 'local'){
                if (error.response != null){
                    let status = error.response.status
                    console.log(status)
                    switch(status){
                        case 422 :
                            const keys = Object.keys(error.response.data.errors)
                            //console.log(keys);
                            for(const key of keys){
                                //console.log(key)
                                //console.log(error.response.data.errors[key][0])
                                this.errors.push(error.response.data.errors[key][0])
                            }
                        break
                        case 500 :
                            this.errors.push('Internal server error.. silahkan hubungi administrator')
                            break
                        default:
                            this.errors.push('Terjadi error di server..')
                            break
                    }
                }
                else
                    this.errors.push('Terjadi error di server..')
            }
            console.log('handle error')
            this.notify()
            this.$vs.loading.close()
        },
        handleSuccess: function(){
            this.$vs.loading.close()
            this.$vs.notify({title:'Success',text:'Data berhasil disimpan..',color:'success'})
            //this.$router.push('/jurnal/ju');
            this.$router.push({name : 'agenlist'});
        },
        notify: function(){
            this.$vs.notify({
                title:'Gagal Menyimpan Data',
                text:'Click untuk melihat',
                color:'danger',
                fixed:false,
                icon: 'warning',
                click:()=>{
                    window.scrollTo(0,0);
                },
            })
        }
    },
    watch:{
        'formdata.prop_id': function(){
            var self = this
            let arrKab = this.optpropinsi.filter(item => item.prop_id == self.formdata.prop_id)
            
            this.optkabupaten = arrKab.map(item => item.kabpropinsi).flat()
            console.log(this.optkabupaten)
        },
    },
    mounted: function () {
        this.getAllData();
    },
  }
</script>